import { SVGAttributes } from "react";

export function TwitterIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="24" height="24" rx="12" fill="white" fillOpacity="0.25" />
      <g clipPath="url(#clip0_1354_35690)">
        <path
          d="M12.9514 11.2321L16.6741 7H15.7919L12.5595 10.6747L9.97773 7H7L10.9041 12.5568L7 16.9949H7.88222L11.2958 13.1142L14.0223 16.9949H17L12.9511 11.2321H12.9514ZM11.743 12.6058L11.3475 12.0524L8.20009 7.64951H9.55512L12.0951 11.2028L12.4907 11.7561L15.7923 16.3749H14.4373L11.743 12.606V12.6058Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1354_35690">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(7 7)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
